import type { DrawingSettings, DrawingTool } from "../canvas/canvasTypes";
import { pressureToWidthFactor } from "../canvas/pressure";

export type BrushTexture = "solid" | "marker" | "crayon" | "eraser";

export interface BrushDefinition {
  tool: DrawingTool;
  label: string;
  widthMultiplier: number;
  baseOpacity: number;
  interpolationSpacing: number;
  pressureSensitive: boolean;
  texture: BrushTexture;
}

export interface BrushStyle {
  colour: string;
  width: number;
  opacity: number;
  texture: BrushTexture;
}

export function resolveBrushStyle(
  brush: BrushDefinition,
  settings: DrawingSettings,
  pressure: number,
): BrushStyle {
  const pressureFactor = brush.pressureSensitive ? pressureToWidthFactor(pressure) : 1;

  return {
    colour: settings.colour,
    width: Math.max(0.5, settings.size * brush.widthMultiplier * pressureFactor),
    opacity: brush.texture === "eraser" ? 1 : Math.min(1, settings.opacity * brush.baseOpacity),
    texture: brush.texture,
  };
}
